import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const holdingCompanySelector = ({ holdingCompany }: ReducerState) => holdingCompany;
export const holdingCompanyLoadingSelector = createSelector(
  holdingCompanySelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
